import * as actionTypes from '../types/adminMessages';

const initialState = {
  filter: [],
  messagesList: [],
  messageTypeFilter: [],
  messageXmlData: null,
  filterGet: {
    okRequest: false,
    loading: false
  },
  messagesListGet: {
    okRequest: false,
    loading: false
  },
  messagesReset: {
    okRequest: false,
    loading: false
  },
  messageXmlGet: {
    okRequest: false,
    loading: false
  },
  messageTypeFilterGet: {
    okRequest: false,
    loading: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_MESSAGES_FILTER:
      return {
        ...state,
        filterGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_MESSAGES_FILTER_SUCCESS:
      return {
        ...state,
        filter: payload,
        filterGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGES_FILTER_FAIL:
      return {
        ...state,
        filterGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGE_TYPE_FILTER:
      return {
        ...state,
        messageTypeFilterGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_MESSAGE_TYPE_FILTER_SUCCESS:
      return {
        ...state,
        messageTypeFilter: payload,
        messageTypeFilterGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGE_TYPE_FILTER_FAIL:
      return {
        ...state,
        messageTypeFilterGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.CLEAR_MESSAGES_FILTER:
      return {
        ...state,
        filter: [],
        filterGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGES:
      return {
        ...state,
        messagesList: [],
        messagesListGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_MESSAGES_SUCCESS:
      return {
        ...state,
        messagesList: payload,
        messagesListGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGES_FAIL:
      return {
        ...state,
        messagesListGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.RESET_MESSAGES:
      return {
        ...state,
        messagesReset: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.RESET_MESSAGES_SUCCESS:
      return {
        ...state,
        messagesReset: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.RESET_MESSAGES_FAIL:
      return {
        ...state,
        messagesReset: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGE_XML:
      return {
        ...state,
        messageXmlGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_MESSAGE_XML_SUCCESS:
      return {
        ...state,
        messageXmlData: payload,
        messageXmlGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_MESSAGE_XML_FAIL:
      return {
        ...state,
        messageXmlData: [],
        messageXmlGet: {
          okRequest: false,
          loading: false
        }
      };

    default:
      return state;
  }
};

export default reducer;
